import { render, staticRenderFns } from "./RelationshipTagLink.vue?vue&type=template&id=b72c6cee&scoped=true"
import script from "./RelationshipTagLink.vue?vue&type=script&lang=js"
export * from "./RelationshipTagLink.vue?vue&type=script&lang=js"
import style0 from "./RelationshipTagLink.vue?vue&type=style&index=0&id=b72c6cee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72c6cee",
  null
  
)

export default component.exports